export const computeFrequency = (itemToRank, data)=> {

    let freq = 0;
    for (let item of data) {
        if (item === itemToRank) {
            ++freq
        }
    }

    return {
        item: itemToRank,
        noOfRespondents: freq
    }
}

/**
 * 
 * @param {itemsToRank} items to compute distribution for
 * @param {*} data to be used to compute frequency of each item
 */
export const computeOverallFrequencyDist = (itemsToRank, data) => {
    if (!itemsToRank || !data) return []
    return itemsToRank.map(itemToRank=> {
        return computeFrequency(itemToRank, data)
    })
}

  /**
     * 
     * @param {itemsToRank} items to compute distribution for
     * @param {*} data to be used to compute frequency of each item
     */
    export const computeOverallProportionDist = (overallFrequencyDistn, numExamples)=> {
        if (!overallFrequencyDistn || !numExamples) return []
        
       // let total = null;
      
        // const totalRespondents = overallFrequencyDistn.reduce((total, currDatapoint)=>{
        //         return total +  currDatapoint.noOfRespondents ;
        // }, 0)

        const totalRespondents = numExamples;

        return overallFrequencyDistn.map((row)=>{
            const percentOfRespondents = totalRespondents > 0 ? roundToDp((row.noOfRespondents / totalRespondents) * 100,1) : 0;
            return {
                item: row.item,
                percentOfRespondents
            }
            
        })
    
    }

export const computeDimensionCategoryFrequency = (item, dimension, dimCategory, surveyData, itemsToRankCol)=> {
        if (!surveyData || !dimension) return []

        let noOfRespondents = 0;
        for (let row of surveyData) {
             
            if (row[itemsToRankCol] === item && row[dimension] === dimCategory) {
                ++noOfRespondents
            }
        }

        return {
            item,
            dimCat: dimCategory,
            
            noOfRespondents: noOfRespondents
        }

    }

export const computeDimensionCategoryFrequencyDistn = (itemsToRank, dimension, dimCategory, surveyData, itemsToRankCol)=>{
    if (!surveyData) return [];

    return itemsToRank.map(item => {
        return computeDimensionCategoryFrequency(item, dimension, dimCategory, surveyData, itemsToRankCol)
    })
}


export const computeDimensionCategoryProportionDistn = (dimensionDist, numExamples) => {
    if (!dimensionDist) return []
    
   // let total = null;
  
    // const totalRespondents = dimensionDist.reduce((total, currDatapoint)=>{
    //         return total +  currDatapoint.noOfRespondents ;
    // }, 0)

    const totalRespondents = numExamples;

    return dimensionDist.map((datapoint)=>{
        const percentOfRespondents = totalRespondents > 0 ? roundToDp((datapoint.noOfRespondents / totalRespondents) * 100,1) : 0;
        return {
            dimCat: datapoint.dimCat,
            percentOfRespondents,
            item: datapoint.item
        }
        
    })

}

export const dataIsAvailable = (percentOfRespondentsList) => {
    if (!percentOfRespondentsList || percentOfRespondentsList.length === 0) return 

    let found = false;
    let  i = 0
    while (!found && i < percentOfRespondentsList.length) {
        if (percentOfRespondentsList[i++] > 0) {
            found = true;
        }
    }

    return found
}


export const computeSortedChartData = (proportionDistnTable) => {

    if (!proportionDistnTable) return {};

    const sortedProportionDistnTable = proportionDistnTable.sort((rowA,rowB)=> rowB.percentOfRespondents - rowA.percentOfRespondents)
    const sortedItemsToRank = sortedProportionDistnTable.map((dataPoint, index)=> dataPoint.item)
    const sortedPercentOfRespondents = sortedProportionDistnTable.map(dataPoint=> dataPoint.percentOfRespondents)

    return {
        itemsToRank: sortedItemsToRank,
        percentOfRespondents: sortedPercentOfRespondents
    }
}

export const roundToDp = (num, dec) => {
       
    if ((typeof num !== 'number') || (typeof dec !== 'number'))
        return false;

    var num_sign = num >= 0 ? 1 : -1;

    return Number( (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec) );
}



